import { defineStore } from 'pinia';
import {
  useListOutboundDeliveryApi,
  type ListOutboundDeliveryResponse,
} from '../api/listOutboundDeliveryApi';
import { useOutboundDeliveryStore } from './outboundDeliveryStore';
import { useRefreshStore } from '@/common/composables/refreshStore';

export const useRefreshOutboundDeliveryStore = defineStore('refresh-outbound-deliveries', () => {
  const listOutboundDeliveryApi = useListOutboundDeliveryApi();
  const store = useOutboundDeliveryStore();

  return useRefreshStore<ListOutboundDeliveryResponse>({
    fetchFromServer: () => listOutboundDeliveryApi.execute(),
    mergeToStore(response) {
      store.merge(response.deliveries);
    },
  });
});
